import type { SvgIconProps } from '@mui/material/SvgIcon'
import SvgIcon from '@mui/material/SvgIcon'

function SidebarIcon(props: Readonly<SvgIconProps>) {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16">
      <rect fill="none" height="11" rx="2.5" stroke="currentColor" strokeWidth={1.25} width="13" x="1.5" y="2.5" />
      <line stroke="currentColor" strokeLinecap="round" strokeWidth={1.25} x1="6" x2="6" y1="3" y2="13" />
    </SvgIcon>
  )
}

export default SidebarIcon
